const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const assign = require('object-assign');
const ReactRouter = require('react-router-dom');
const Router = ReactRouter.Router;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Button = FuzzyReaction.Components.Global.Button;
const Column = Form.Column;
const Row = Form.Row;
const FormStore = FuzzyReaction.Stores.FormStore;
const Label = require("../../../components/global/components/Label.js");
const CodeStore = require('../../../stores/CodeStore');
const DayPicker = require('react-day-picker');
require('react-day-picker/lib/style.css');
const _ = require("lodash");

const CreateCode = createReactClass({
    displayName: 'CreateCode',

    getInitialState: function () {
        this.handleDayClick = this.handleDayClick.bind(this);
        this.state = {
            selectedDay: undefined,
        };
        return {
            workingResource: {},
            params: {},
            formIsValid: false,
        }
    },

    resourceActions: new ResourceActions('generation-codes'),

    /**
     * Edit user form key
     */
    formKey: 'editCode',

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {},
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {},
        dataNode: 'data'
    },

    /**
     * Determine the page title based on present data
     *
     * @returns {string}
     * @private
     */
    _determinePageTitle: function () {
        if (typeof this.state.workingResource.id !== 'undefined') {
            return this.state.workingResource.name;
        } else {
            return 'Generate Codes';
        }
    },

    handleDayClick: function (dayClicked) {
        // get year, month, and day part from the date
        const year = dayClicked.toLocaleString("en-US", {year: "numeric"});
        const month = dayClicked.toLocaleString("en-US", {month: "2-digit"});
        const day = dayClicked.toLocaleString("en-US", {day: "2-digit"});

        // get the form resource
        const resource = FormStore.getResource(this.formKey);

        // generate yyyy-mm-dd 00:00:00 date string
        resource.expiration = `${year}-${month}-${day} 00:00:00`;

        this.setState({
            selectedDay: dayClicked,
            workingResource: resource,
            formIsValid: FormStore.isFormValid(this.formKey)
        });
    },

    /**
     * Request instructor data
     *
     * @param modifiers
     */
    requestCodeData: function (modifiers) {
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});
        this.resourceActions.getResource(this.state.params.id, this.getOptions);
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        const params = this.props.match.params || {};
        this.setState({
            params: params,
            resourceOperation: typeof params.id === 'undefined' ? 'create' : 'edit'
        }, function () {
            if (this.state.resourceOperation === 'edit') {
                this.requestCodeData();
            }
        });

        this.changeListener = this._onChange;
        CodeStore.addChangeListener(this.changeListener);
        FormStore.addChangeListener(this.bindResource);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        CodeStore.removeChangeListener(this.changeListener);
        FormStore.removeChangeListener(this.bindResource);
    },

    /**
     * Change handler for FormStore changes
     */
    bindResource: function () {
        this.setState({
            workingResource: FormStore.getResource(this.formKey),
            formIsValid: FormStore.isFormValid(this.formKey)
        });
    },

    refresh: function () {
        Router.dispatch(this.props.location.getCurrentPath(), null);
    },

    /**
     * Action handlers
     *
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'save':
                this.performOperation();
                this.props.history.push('/codes');
                this.refresh();
                break;
            case 'goBack':
                this.props.history.push('/codes');
                break;
        }
    },

    /**
     * Handle change events
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            workingResource: CodeStore.getResource(),
            formIsValid: FormStore.isFormValid(this.formKey)
        });
    },

    /**
     * Fire the activate code action
     */
    performOperation: function () {
        if (this.state.resourceOperation === 'create') {
            this.resourceActions.createResource(this.state.workingResource, this.sendOptions);
        } else if (this.state.resourceOperation === 'edit') {
            this.resourceActions.updateResource(this.state.workingResource, this.sendOptions);
        }
    },

    _disable: function () {
        return this.state.resourceOperation === 'edit';
    },

    _buttonCreateName: function () {
        return this.state.resourceOperation === 'edit' ? "Save" : "Create";
    },

    _isAfter: function () {
        return this.state.resourceOperation !== 'edit' ? ",isAfter" : ""
    },

    /**
     * Require some validations for the instructor
     *
     * @returns {boolean}
     * @private
     */
    _isCodeValid: function () {
        const code = this.state.workingResource;
        // Require a password for new instructors
        if (typeof code.id === 'undefined' &&
            (typeof code.prefix === 'undefined' || (code.prefix.length < 1 && code.prefix.length > 10))) {
            return false;
        }

        if (typeof code.num_codes === 'undefined' || code.num_codes.length < 1 || code.num_codes === 0) {
            return false;
        }

        if (typeof code.expiration === 'undefined' || code.expiration.length < 1) {
            return false;
        }

        if (typeof code.num_days === 'undefined' || code.num_days === 0) {
            return false;
        }

        if (code.num_days.length < 1 && code.num_days.length > 10) {
            return false;
        }

        return !(code.num_days === 'undefined' || code.num_days < 1);
    },

    handleInputChange: function (event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.state.workingResource.unique = value ? "on" : null;
        const inputs = $("input.form-input");
        for (let i = 0; i < inputs.length; i++) {

            if (inputs[i].placeholder === "123") {
                const ev = new Event('input', {bubbles: true});
                ev.simulated = true;
                inputs[i].disabled = this.state.workingResource.unique != null;
                inputs[i].value = this.state.workingResource.unique == null ? inputs[i].value : 1;
                inputs[i].dispatchEvent(ev);
            }
        }

    },

    render: function () {
        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"></div>
                    <Row>
                        <Column grid="lg" size="6">
                            <h1 className="page-header">{this._determinePageTitle()}</h1>
                        </Column>
                    </Row>
                    <Column grid="lg" size="10" classes="offset-lg-1">
                        <div className="card card-default">
                            <div className="card-body">
                                <Row>
                                    <Column grid="lg" size="12">
                                        <Form key={this.formKey + this.state.workingResource.id} formKey={this.formKey}
                                              bindResource={this.state.workingResource}>
                                            <Row>
                                                <Column grid="sm" size="6">

                                                    <Form.Input disabled={this._disable()} fieldKey="prefix" type="text"
                                                                label="Prefix"
                                                                placeholder="PREF" limit={10}
                                                                validations="isAlphanumeric,isLength:3:10,isUppercase"
                                                                required={true}/>
                                                    <Form.Input fieldKey="expiration" type="text" label="Expiration"
                                                                placeholder="yyyy-mm-dd" limit={10}
                                                                validations={"isLength:10:20" + this._isAfter()}
                                                                required={true}/>
                                                    <div>
                                                        <DayPicker
                                                            onDayClick={this.handleDayClick}
                                                            selectedDays={new Date(this.state.workingResource.expiration)}
                                                        />
                                                    </div>
                                                </Column>

                                                <Column grid="sm" size="6">
                                                    <Form.Input disabled={this._disable()} class="tooltip"
                                                                fieldKey="num_days" type="number" label="Length"
                                                                placeholder="12345" limit={3}
                                                                validations="isLength:1:3,isNumeric" required={true}/>

                                                    <Form.Input
                                                        disabled={this.state.workingResource.unique != null}
                                                        fieldKey="num_codes" type="number" label="Codes"
                                                        placeholder="123" limit={5} validations="isLength:1:5,isNumeric"
                                                        required={true}/>

                                                    {/*TODO: FIX THIS*/}
                                                    <Label title="Unique:"/>
                                                    <input onChange={this.handleInputChange}
                                                           checked={this.state.workingResource.unique} fieldKey="unique"
                                                           type="checkbox"/>
                                                </Column>
                                            </Row>
                                        </Form>
                                    </Column>
                                </Row>
                                <Row classes="justify-content-end">
                                    <Button action="goBack" text="Go Back" handleAction={this.handleAction}/>
                                    <Button action="save" disabled={!(this._isCodeValid() && this.state.formIsValid)}
                                            text={this._buttonCreateName()} handleAction={this.handleAction}
                                            mods={['primary']}/>
                                </Row>
                            </div>
                        </div>
                    </Column>
                </div>
            </div>
        );
    },
});

module.exports = CreateCode;
